module.exports = __webpack_public_path__ + "static/media/  (149).fb74de4d.jpg";